/**
 * region for helpers*/
import validation from '../validation';
import typing from '../typing';

class dictionary {

    static rule(ruleName, injectedArguments) {
        if (!typing.isArray(injectedArguments)) {
            injectedArguments = [injectedArguments];
        }

        return function () {
            const wrappedArguments = [...injectedArguments, ...arguments];
            return validation.rules[ruleName].apply(null, wrappedArguments);
        };
    }

    static WEB_PRODUCTS = {
        PRODUCTTITLE: {
            alias: 'Product title',
            rules: ['required']
        },
        DESCRIPTION: {
            alias: 'Product description',
            rules: [dictionary.rule('maxLength', 1000)]
        },
        BRAND_NAME: {
            alias: 'Brand'
        },
        MODEL_NO: {
            alias: 'Model number'
        },
        IDCONTENTTYPE: {
            alias: 'Content type',
            rules: ['required']
        },
        UPLOAD_FILE: {
            alias: 'Upload file',
            rules: [
                dictionary.rule('accept', [['zip']]),
                dictionary.rule('maxSize', [[500000]])
            ]
        },
        URL: {
            alias: 'Product url',
            rules: ['url']
        },
        IDCONDITION: {
            alias: 'Condition'
        }
    };

    static KEYWORDS = {
        KEYWORD: {
            alias: 'Keyword name',
            rules: [
                'isKeywordRepeated',
                'required'
            ]
        }
    }

}


export default dictionary;
